export default __webpack_public_path__ + "static/media/logo5.6bc0a678.png";